import AssetCards from './AssetCards';

export default AssetCards;
